import { Mesh, MeshStandardMaterial, Object3D } from "three";

export const onBeforeCompileBloom = (shader: any) => {
  // Renders material as black
  shader.uniforms.globalBloom = window.RPR.globalBloom;
  shader.fragmentShader = `
    uniform float globalBloom;
    ${shader.fragmentShader}
  `.replace(
    `#include <dithering_fragment>`,
    `#include <dithering_fragment>
      if (globalBloom > 0.5) {
        gl_FragColor.rgb = vec3(0);
      }
      
    `
  );
};

/**
 * This is a save way to add objects to the scene during runtime.
 * It is needed in bloom enabled experiences to that the object isn't blooming per default.
 * If it needs to be blooming this function isn't needed.
 * @param object the object to be added to the scene
 * @param parent the parent of the added object. Can be scene
 */
export const addToSceneWithoutBloom = (object: Object3D, parent: Object3D) => {
  object.traverse((obj) => {
    if ((obj as Mesh).isMesh) {
      const onBeforeCompileCopy = (
        (obj as Mesh).material as MeshStandardMaterial
      ).onBeforeCompile;
      ((obj as Mesh).material as MeshStandardMaterial).onBeforeCompile = (
        shader,
        renderer
      ) => {
        onBeforeCompileCopy(shader, renderer);
        onBeforeCompileBloom(shader);
      };
    }
  });
  parent.add(object);
};
